import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as Actions from '../../auth/actions';
import ForgotPasswordComponent from '../components/ForgotPasswordComponent';

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    forgotPassword: (email: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.forgotPassword(email, resolve, reject));
      });
    }
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxForgotPassword = ConnectedProps<typeof connector>;

export default withRouter(connector(ForgotPasswordComponent));
